import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attandances--csv-import"
export default class extends Controller {
  static targets = ["submitBtn", "overlay"]

  connect() {
    // Initially disable submit button until file is selected
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.classList.add("btn-secondary")
      this.submitBtnTarget.classList.remove("btn-primary")
    }
  }

  selectFile(event) {
    const fileInput = event.target
    const file = fileInput.files[0]

    if (file) {
      // Enable submit button when file is selected
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.classList.remove("btn-secondary")
      this.submitBtnTarget.classList.add("btn-primary")
    } else {
      // Disable submit button when no file
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.classList.remove("btn-primary")
      this.submitBtnTarget.classList.add("btn-secondary")
    }
  }

  showOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("d-none")
    }

    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
    }
  }
}
